import React, { useState, useEffect } from "react";
import { DTOReportesEmbarquesDespachados } from "../../../../DTO/Reportes/Embarques/DTOReportesEmabarquesDespachados";
import ReportesCorresponsaliasService from "../../../../Services/Reportes/ReportesCorresponsalias.Service";
import { Card, Row, Col, Form, Button } from "react-bootstrap";
import { CellIcon } from "../../../Utils/CellIcon/CellIcon";
import { FaDownload } from "react-icons/fa";
import DataTable from "react-data-table-component";

export const EmbarquesDespachados: React.FC = () => {
    const gridRef = React.useRef<any>(null)
    const [Inicio, setInicio] = useState(currentDate(-7))
    const [Fin, setFin] = useState(currentDate(0))
    const [filteredData, setFilteredData] = useState<DTOReportesEmbarquesDespachados[]>([]);
    const [EmbarquesDespachados, setEmbarquesDespachados] = useState<DTOReportesEmbarquesDespachados[]>([]);
    const columnDefs = [
        {name: 'id', selector:(row: DTOReportesEmbarquesDespachados) => row.id, sortable: true},
        {name: 'ADUANA', selector:(row: DTOReportesEmbarquesDespachados) => row.aduana, sortable: true},
        {name: 'TIPO DE EMBARQUE', selector:(row: DTOReportesEmbarquesDespachados) => row.tipoEmbarque, sortable: true},
        {name: 'DESTINO', selector:(row: DTOReportesEmbarquesDespachados) => row.destino, sortable: true},
        {name: 'DIAS EN ADUANA', selector:(row: DTOReportesEmbarquesDespachados) => row.diasEnAduana, sortable: true},
        {name: 'NOMBRE', selector:(row: DTOReportesEmbarquesDespachados) => row.nombre, sortable: true},
        {name: 'TRAFICO', selector:(row: DTOReportesEmbarquesDespachados) => row.trafico, sortable: true},
        {name: 'REFERENCIA', selector:(row: DTOReportesEmbarquesDespachados) => row.referencia, sortable: true},
        {name: 'NO DE PEDIMENTO', selector:(row: DTOReportesEmbarquesDespachados) => row.noPedimento, sortable: true},
        {name: 'CLAVE DE PEDIMENTO', selector:(row: DTOReportesEmbarquesDespachados) => row.clavePedimento, sortable: true},
        {name: 'TIPO', selector:(row: DTOReportesEmbarquesDespachados) => row.tipo, sortable: true},
        {name: 'ORDEN DE COMPRA', selector:(row: DTOReportesEmbarquesDespachados) => row.ordenCompra, sortable: true},
        {name: 'FACTURA', selector:(row: DTOReportesEmbarquesDespachados) => row.factura, sortable: true},
        {name: 'PROVEEDOR', selector:(row: DTOReportesEmbarquesDespachados) => row.proveedor, sortable: true},
        {name: 'DESCRIPCION', selector:(row: DTOReportesEmbarquesDespachados) => row.descripcionMercancia, sortable: true},
        {name: 'LINEA TRANSPORTISTA INTERNACIONAL', selector:(row: DTOReportesEmbarquesDespachados) => row.lineaTransportistaInternacional, sortable: true},
        {name: 'LINEA NAVIERA', selector:(row: DTOReportesEmbarquesDespachados) => row.lineaNaviera, sortable: true},
        {name: 'MAWB', selector:(row: DTOReportesEmbarquesDespachados) => row.MAWB, sortable: true},
        {name: 'HAWB', selector:(row: DTOReportesEmbarquesDespachados) => row.HAWB, sortable: true},
        {name: 'FECHA DE NOTIFICACION', selector:(row: DTOReportesEmbarquesDespachados) => row.fechaNotificacion.toDateString(), sortable: true},
        {name: 'BULTOS', selector:(row: DTOReportesEmbarquesDespachados) => row.bultos, sortable: true},
        {name: 'CANTIDAD DE CONTENEDORES', selector:(row: DTOReportesEmbarquesDespachados) => row.cantidadContenedores, sortable: true},
        {name: 'NO. CONTENEDORES', selector:(row: DTOReportesEmbarquesDespachados) => row.numerosContenedores, sortable: true},
        {name: 'PESO BRUTO', selector:(row: DTOReportesEmbarquesDespachados) => row.pesoBruto, sortable: true},
        {name: 'PESO NETO', selector:(row: DTOReportesEmbarquesDespachados) => row.pesoNeto, sortable: true},
        {name: 'INCOTERM', selector:(row: DTOReportesEmbarquesDespachados) => row.incoterm, sortable: true},
        {name: 'FECHA ETA', selector:(row: DTOReportesEmbarquesDespachados) => row.fechaETA.toDateString(), sortable: true},
        {name: 'FECHA DE ENTRADA', selector:(row: DTOReportesEmbarquesDespachados) => row.fechaEntrada.toDateString(), sortable: true},
        {name: 'FECHA DE REVALIDACION GUIA', selector:(row: DTOReportesEmbarquesDespachados) => row.fechaRevalidacionGuia.toDateString(), sortable: true},
        {name: 'MONTO USD',  cellRenderer: (params: any) => {return `$ ${params.data.montoUSD}`}},
        {name: 'ORIGEN', selector:(row: DTOReportesEmbarquesDespachados) => row.origen, sortable: true},
        {name: 'FRACCION ARANCELARIA', selector:(row: DTOReportesEmbarquesDespachados) => row.fraccionArancelaria, sortable: true},
        {name: 'DESCRIPCION', selector:(row: DTOReportesEmbarquesDespachados) => row.descripcion, sortable: true},
        {name: 'PREFERENCIA ARANCELARIA', selector:(row: DTOReportesEmbarquesDespachados) => row.preferenciaArancelaria, sortable: true},
        {name: 'ESTATUS', selector:(row: DTOReportesEmbarquesDespachados) => row.estatus, sortable: true},
        {name: 'OBSERVACIONES', selector:(row: DTOReportesEmbarquesDespachados) => row.observaciones, sortable: true},
        {name: 'FECHA DE INICIO DE GASTOS DE ALMACENAJE', selector:(row: DTOReportesEmbarquesDespachados) => row.fechaInicioGastosAlmacenaje.toDateString(), sortable: true},
        {name: 'COSTO DIARIO ALMACENAJE',  cellRenderer: (params: any) => {return `$ ${params.data.costoDiarioAlmacenaje}`}},
        {name: 'COSTO DIARIO CONEXION',  cellRenderer: (params: any) => {return `$ ${params.data.costoDiarioConexion}`}},
        {name: 'TOTAL A PAGAR ALMACENAJE',  cellRenderer: (params: any) => {return `$ ${params.data.totalPagar}`}},
        {name: 'TOTAL A PAGAR CONEXION', cellRenderer: (params: any) => {return `$ ${params.data.totalPagarConexion}`}},
        {name: 'FECHA DE PAGO PEDIMENTO', selector:(row: DTOReportesEmbarquesDespachados) => row.fechaPagoPedimento.toDateString(), sortable: true},
        {name: 'FECHA DE INSTRUCCIONES', selector:(row: DTOReportesEmbarquesDespachados) => row.fechaInstrucciones.toDateString(), sortable: true},
        {name: 'HORA DE INSTRUCCIONES', selector:(row: DTOReportesEmbarquesDespachados) => row.horaInstrucciones, sortable: true},
        {name: 'FECHA DE DESPACHO', selector:(row: DTOReportesEmbarquesDespachados) => row.fechaDespacho.toDateString(), sortable: true},
        {name: 'DIAS C/PDTO PAGADO', selector:(row: DTOReportesEmbarquesDespachados) => row.diasCPPagado, sortable: true},
        {name: 'FECHA SALIDA DE CONTENEDORES', selector:(row: DTOReportesEmbarquesDespachados) => row.fechaSalidaContenedores.toDateString(), sortable: true},
        {name: 'NOMBRE DE PAQUETERIA O TRANSPORTISTA', selector:(row: DTOReportesEmbarquesDespachados) => row.nombrePaqueteria, sortable: true},
        {name: 'NO. DE GUIA DE EMBARQUE A DESTINO', selector:(row: DTOReportesEmbarquesDespachados) => row.noGuiaEmbarqueDestino, sortable: true},
        {name: 'FECHA DE ENTREGA EN DESTINO FINAL', selector:(row: DTOReportesEmbarquesDespachados) => row.fechaEntregaDestinoFinal.toDateString(), sortable: true},
        {name: 'HORA DE ENTREGA EN DESTINO FINAL', selector:(row: DTOReportesEmbarquesDespachados) => row.horaEntregaDestinoFinal, sortable: true},
        {name: 'FACTURA',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.facturaCorresponsal} idTrafico={params.data.id} proceso={16} ></CellIcon>
        }},
        {name: 'CERTIFICADO DE CALIDAD',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.certificadoCalidad} idTrafico={params.data.id} proceso={15} ></CellIcon>
        }},
        {name: 'PACKING LIST',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.packingList} idTrafico={params.data.id} proceso={18} ></CellIcon>
        }},
        {name: 'HOJA TECNICA',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.hojaTecnica} idTrafico={params.data.id} proceso={17} ></CellIcon>
        }},
        {name: 'BL',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.bl} idTrafico={params.data.id} proceso={14} ></CellIcon>
        }},
        {name: 'PEDIMENTO INFORMATIVO',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.pedimentoInformativo} idTrafico={params.data.id} proceso={12} ></CellIcon>
        }, width: '130'},
        {name: 'PEDIMENTO SIMPLIFICADO',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.pedimentoSimplificado} idTrafico={params.data.id} proceso={13} ></CellIcon>
        }, width: '130'},
        {name: 'DODA',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.doda} idTrafico={params.data.id} proceso={11} ></CellIcon>
        }, width: '100'},
        {name: 'HONORARIOS AA', cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.honorarios} idTrafico={params.data.id} proceso={37} ></CellIcon>
        }, width: '130'},
        {name: 'TOTAL HONORARIOS AA', cellRenderer: (params: any) => {return `$ ${params.data.totalHonorarios}`}},
        {name: 'GASTOS A TERCEROS', cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.gastosTerceros} idTrafico={params.data.id} proceso={41} ></CellIcon>
        }, width: '130'},
        {name: 'TOTAL GASTOS A TERCEROS', cellRenderer: (params: any) => {return `$ ${params.data.totalGastosTerceros}`}},
        {name: 'COMPROBANTES GASTOS A TERCEROS', cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.comprobantesGastosTerceros} idTrafico={params.data.id} proceso={2} ></CellIcon>
        }, width: '130'},
        {name: 'PRUEBA DE ENTREGA', selector:(row: DTOReportesEmbarquesDespachados) => row.pruebaEntrega, sortable: true},
        {name: 'DESCARGAR TODOS', cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.hasFile} idTrafico={params.data.id} proceso={0} ></CellIcon>
        }, width: '130'},
    ];

    function currentDate(days: number): string {
        var today = new Date()
        today.setDate(today.getDate() + days)
        var dd = String(today.getDate()).padStart(2, '0')
        var mm = String(today.getMonth() + 1).padStart(2, '0')
        var yyyy = today.getFullYear()
        return yyyy + '-' + mm + '-' + dd
    }

    const GetEmbarquesDespachados = () => {
        ReportesCorresponsaliasService.getReporteEmbarquesDespachados(Inicio, Fin)
        .then(res => {
            setEmbarquesDespachados(res.data)
            setFilteredData(res.data)
        });
    }

    const filtraEmbarques = (e: any) => {
        gridRef.current.api.setQuickFilter(e.target.value)
    }

    const exportarEmbarques = () => {
        ReportesCorresponsaliasService.GetExcelDespachados(Inicio, Fin)
        .then(resp => {
            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `ReporteEmbarquesDespachados.xlsx`);
            document.body.appendChild(link);
            link.click();
        })
    }

    return (
        <>
        <Card>
            <Card.Body>
                <Row>
                    <Col xs={3}>
                    <Form.Label style={{width:'100%'}}>
                        Fecha Inicial
                        <Form.Control
                            defaultValue={Inicio}
                            type='date'
                            name='Inicio'
                            placeholder='Inicio'
                            title='Inicio'
                            alt='Inicio'
                            data-date-format='YYYY-mm-dd'
                            onChange={(e) => setInicio(e.target.value)}
                            size='sm'
                        />
                    </Form.Label>
                    </Col>
                    <Col xs={3}>
                    <Form.Label style={{width:'100%'}}>
                        Fecha Final
                        <Form.Control
                            defaultValue={Fin}
                            type='date'
                            name='Fin'
                            placeholder='Fin'
                            title='Fin'
                            alt='Fin'
                            onChange={(e) => setFin(e.target.value)}
                            size='sm'
                        />
                    </Form.Label>
                    </Col>
                    <Col style={{margin:'auto 0px'}}>
                        <Button className="me-2" variant="primary" onClick={GetEmbarquesDespachados}>Generar</Button>
                        { EmbarquesDespachados.length > 0 ? <Button onClick={exportarEmbarques}><FaDownload/>&nbsp;Excel</Button> : "" }
                    </Col>
                </Row>
            </Card.Body>
        </Card>
        <Card className='mt-2' style={{visibility: EmbarquesDespachados.length > 0 ? "visible" : "hidden"}}>
            <Card.Body>  
                <Row className="mb-2">
                    <Col xs={5}>
                        <Form.Control
                            type='text'
                            size='sm'
                            placeholder='Search...'
                            onChange={(e) => {
                                filtraEmbarques(e)
                            }}
                        />
                    </Col>
                </Row>
                <div className='pt-2'>
                    <Col xs={12}>
                    <DataTable
                        noHeader
                        defaultSortFieldId={'id'}
                        defaultSortAsc={true}
                        pagination
                        paginationPerPage={15}
                        striped={true}
                        dense={true}
                        highlightOnHover
                        columns={columnDefs}
                        data={EmbarquesDespachados}
                        /* expandableRows={Perfil === "Administrador" || Perfil === "GEMCO"}
                        expandableRowsComponent={({data}) => {
                            return (
                            <RptFacturasDetail idHeader={data.id} showMsg={
                                (type:string, message: string) => {
                                    showToastMessage(type, message)
                                }
                                }
                            />
                            )
                        }} */
                    />
                    </Col>
                </div>
            </Card.Body>
        </Card>
        </>
    );
}